export enum ServiceLimitEnforcementStrategyName {
  rrule = 'rrule',
}

export type ServiceLimitEnforcementStrategyNameType = keyof typeof ServiceLimitEnforcementStrategyName;
